import React from "react";
type TrashCanProps = {
  color?: string;
};

const TrashCan: React.FC<TrashCanProps> = ({ color = "#000" }) => {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 0L3.75 0.75H0V2.25H0.75V13.5C0.75 13.8917 0.893497 14.291 1.17627 14.5737C1.45904 14.8565 1.85833 15 2.25 15H9.75C10.1417 15 10.541 14.8565 10.8237 14.5737C11.1065 14.291 11.25 13.8917 11.25 13.5V2.25H12V0.75H8.25L7.5 0H4.5ZM2.25 2.25H9.75V13.5H2.25V2.25ZM3.75 3.75V12H5.25V3.75H3.75ZM6.75 3.75V12H8.25V3.75H6.75Z"
        fill={color}
      />
    </svg>
  );
};

export default TrashCan;
